<template>
  <div class="link">
    <span class="link-icon">
      <img :src="'data:image/png;base64,' + icon" alt="icon">
    </span>
    <div class="link-content">
      <span class="link-title">
        {{name}}
      </span>
      <a href="#" class="remove-app-btn" @click.prevent="removeApp(packageName)">
        <svg width="25" height="32" fill="#7E7E7E">
          <use xlink:href="#icon-trash"></use>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppItem',
  props: ['name', 'icon', 'packageName'],
  data: function () {
    return {
      menuOpen: false,
      isAndroid: window.Android,
    }
  },
  methods: {
    editApp () {
      this.$emit('editapp');
    },
    removeApp (app) {
      this.$emit('removeapp', app);
    }
  }
}
</script>

<style lang="scss">
.remove-app-btn {
  display: flex;
  svg  {
    width: 16px;
    height: auto;
  }
}
</style>
